import { Product, ProductMetafields, imagesState } from '../../../types';

// 画像ファイルをBase64にエンコードする関数
export const encodeFileToBase64 = (file: Blob): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

// 画像ファイルをBase64にエンコードし、フィルタリングする関数
export const encodeAndFilterImages = async (
  images: imagesState,
  productData: { product: Product; product_metafields: ProductMetafields } | undefined,
) => {
  const encodedImages = await Promise.all(
    Object.keys(images).flatMap((key) => {
      const image = images[key];
      if (key === 'additional' && Array.isArray(image)) {
        // additionalキーに対する特別な処理
        return image.map((img, additionalIndex) => {
          if (img && img instanceof File) {
            return encodeFileToBase64(img)
              .then((base64Image) => ({
                mimetype: img.type,
                filename: img.name,
                size: img.size,
                type: `追加画像${additionalIndex + 1}`,
                base64Data: (base64Image as string).split(',')[1], // "data:image/jpeg;base64,"の部分を除去
              }))
              .catch((error) => {
                console.error(`Error encoding file for additional image ${additionalIndex + 1}:`, error);
                return null;
              });
          } else {
            console.error(`Invalid file type for additional image ${additionalIndex + 1}:`, img);
            return null;
          }
        });
      } else if (image && image instanceof File) {
        return [
          encodeFileToBase64(image)
            .then((base64Image) => {
              const mediaIndex = parseInt(key.replace('image', '')) - 1;
              const mediaItem = productData?.product?.media?.[mediaIndex];
              return {
                mimetype: image.type,
                filename: image.name,
                size: image.size,
                type: mediaItem?.alt || '',
                base64Data: (base64Image as string).split(',')[1], // "data:image/jpeg;base64,"の部分を除去
              };
            })
            .catch((error) => {
              console.error(`Error encoding file for key: ${key}`, error);
              return null;
            }),
        ];
      } else {
        console.error(`Invalid file type for key: ${key}`, image);
        return [null];
      }
    }),
  );

  // エンコードされた画像ファイルをフィルタリング
  return encodedImages.flat().filter((image) => image !== null);
};
